<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <template class="header">
          <h4 class="card-title style-title">Follow Up</h4>
          <h5
            class="description style-title"
          >Please fill in all the required details to add the follow up of this investigation.</h5>
        </template>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <card>
          <div class="row justify-content-center">
            <div class="col-lg-4">
              <div class="row justify-content-center">
                <h4
                  class="card-title style-title justify-content-center"
                  style="border-bottom: solid red"
                >Details of officer involve</h4>
              </div>
              <base-input label="Nama" v-model="name"></base-input>
              <base-input label="Jawatan" v-model="designation"></base-input>
              <base-input label="Tarikh Dan Masa">
                <el-date-picker
                  v-model="dateTimePicker"
                  type="datetime"
                  placeholder="Select date and time"
                ></el-date-picker>
              </base-input>
            </div>
            <div class="col-lg-8">
              <div class="row justify-content-center">
                <h4
                  class="card-title style-title justify-content-center"
                  style="border-bottom: solid red"
                >Prevention Step Details</h4>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <base-input label="1. Penghapusan">
                    <textarea class="address" v-model="penghapusan" disabled></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan1"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan1"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input label="2. Penggantian">
                    <textarea class="address" v-model="penggantian" disabled></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan2"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan2"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input label="3. Pengasingan">
                    <textarea class="address" v-model="pengasingan" disabled></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan3"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan3"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input label="4. Kawalan Kejuruteraan">
                    <textarea class="address" v-model="kawalanKejuruteraan" disabled></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan4"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan4"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input label="5. Kawalan Pentadbiran">
                    <textarea class="address" disabled v-model="kawalanPentadbiran"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan5"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan5"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input label="6. Penggunaan PPE">
                    <textarea class="address" disabled v-model="penggunaanPPE"></textarea>
                  </base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Tindakan" v-model="tindakan6"></base-input>
                </div>
                <div class="col-lg-3">
                  <base-input label="Catatan">
                    <textarea class="address" v-model="catatan6"></textarea>
                  </base-input>
                </div>
              </div>
            </div>

            <div class="col-lg-12 text-center">
              <base-button @click="editFollowUp()" type="primary">Edit Follow Up</base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option, Table, TableColumn } from "element-ui";
import { DatePicker, TimeSelect } from "element-ui";
import swal from "sweetalert2";
import { json } from "d3";
import moment from "moment";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      name: "",
      designation: "",
      dateTimePicker: "",
      instID: "",
      penghapusan: "",
      penggantian: "",
      pengasingan: "",
      kawalanKejuruteraan: "",
      kawalanPentadbiran: "",
      penggunaanPPE: "",
      tindakan1: "",
      tindakan2: "",
      tindakan3: "",
      tindakan4: "",
      tindakan5: "",
      tindakan6: "",
      catatan1: "",
      catatan2: "",
      catatan3: "",
      catatan4: "",
      catatan5: "",
      catatan6: ""
    };
  },
  created() {
    this.instID = this.$route.params.instid;
    console.log(this.instID);
    this.getMethod(this.instID);
  },
  methods: {
    getMethod(instid) {
      this.$http.get(`:9994/api/v1/complete/method/${instid}`).then(res => {
        if (!res.error) {
          console.log(res.message);
          const pvStep = res.message.pvStep;
          const followUp = res.message.followUp;

          this.penghapusan = pvStep[0].StepDetail;
          this.penggantian = pvStep[1].StepDetail;
          this.pengasingan = pvStep[2].StepDetail;
          this.kawalanKejuruteraan = pvStep[3].StepDetail;
          this.kawalanPentadbiran = pvStep[4].StepDetail;
          this.penggunaanPPE = pvStep[5].StepDetail;

          this.name = followUp[0].name;
          this.designation = followUp[0].designation;
          this.dateTimePicker = followUp[0].datetime;

          this.tindakan1 = followUp[0].action;
          this.tindakan2 = followUp[1].action;
          this.tindakan3 = followUp[2].action;
          this.tindakan4 = followUp[3].action;
          this.tindakan5 = followUp[4].action;
          this.tindakan6 = followUp[5].action;

          this.catatan1 = followUp[0].note;
          this.catatan2 = followUp[1].note;
          this.catatan3 = followUp[2].note;
          this.catatan4 = followUp[3].note;
          this.catatan5 = followUp[4].note;
          this.catatan6 = followUp[5].note;
        }
      });
    },

    editFollowUp() {
      console.log(moment(this.dateTimePicker).toISOString());
      let body = [
        {
          instid: parseInt(this.instID),
          pvstepid: 1,
          action: this.tindakan1 == "" ? "NONE" : this.tindakan1,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan1
        },
        {
          instid: parseInt(this.instID),
          pvstepid: 2,
          action: this.tindakan2 == "" ? "NONE" : this.tindakan2,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan2
        },
        {
          instid: parseInt(this.instID),
          pvstepid: 3,
          action: this.tindakan3 == "" ? "NONE" : this.tindakan3,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan3
        },
        {
          instid: parseInt(this.instID),
          pvstepid: 4,
          action: this.tindakan4 == "" ? "NONE" : this.tindakan4,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan4
        },
        {
          instid: parseInt(this.instID),
          pvstepid: 5,
          action: this.tindakan5 == "" ? "NONE" : this.tindakan5,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan5
        },
        {
          instid: parseInt(this.instID),
          pvstepid: 6,
          action: this.tindakan6 == "" ? "NONE" : this.tindakan6,
          datetime: moment(this.dateTimePicker).toISOString(),
          name: this.name,
          designation: this.designation,
          note: this.catatan6
        }
      ];

      console.log(body);

      this.$http.post(`:9994/api/v1/complete/action`, body).then(res => {
        if (!res.error) {
          swal({
            title: "Edited!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });

          this.$router.push({ path: `/IncidentReport/FollowUp` });
        }
      });
    }
  }
};
</script>

<style scoped>
.style-title {
  text-align: center;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}

textarea {
  width: 100%;
  height: 110px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

/* textarea:disabled {
  color: white;
} */
.address:disabled {
  opacity: 0.8;
  color: #32325d;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
